module.exports = __webpack_public_path__ + "img/PP-MockUp.a01c309f.png";